




































































import { Component, Emit, Vue } from 'vue-property-decorator';
import {バーコードブック帳票商品型, バーコードブック取込結果型, バーコードブック取込結果区分 } from '@/type/barcodebook/item';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import { progress } from '@/script/progress';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import FileUploadDialog from '@/components/atom/dialog/FileUploadDialog.vue';
import moment from 'moment';
import CompleteDialog from '@/components/atom/dialog/CompleteDialog.vue';

@Component({
  components: {
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    NormalButton,
    AlertDialog,
    FileUploadDialog,
    CompleteDialog,
  },
})
export default class PrintBarcodeBook extends Vue {

  private バーコードブック帳票商品一覧: バーコードブック帳票商品型[] = [];

  private アラートメッセージ: string | string[] | null = null;

  private mounted(): void {
    moment.locale('ja');
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private 印刷ボタン活性確認(): boolean {
    if (0 < this.バーコードブック帳票商品一覧.length) {
       return true;
    }
    return false;
  }

  private クリアする(): void {
    this.バーコードブック帳票商品一覧 = [];
    this.ダイアログを閉じる('クリアダイアログ');
  }

  private async バーコードブックExcel出力をする(): Promise<void> {
    const ファイル名 = 'バーコードブック_' + moment().format('YYYYMMDDhhmmss') + '.xlsx';
    this.ダイアログを閉じる('出力ダイアログ');
    await download.バーコードブックExcelを出力する(ファイル名)
      .catch((error: any) => {
        this.APIアラートダイアログを開く(error.data);
      });
  }

  private async バーコードブックExcel取込をする(アップロードファイル: File): Promise<void> {
    const params = new FormData();
    params.append('file', アップロードファイル);
    await api.バーコードブックExcelを取込する(params)
      .then((response: バーコードブック取込結果型) => {
        this.バーコードブック帳票商品一覧 = response.バーコードブック帳票商品一覧;
        if (response.バーコードブック取込結果区分 !== バーコードブック取込結果区分.取込に成功しました) {
          this.アラートメッセージ = response.バーコードブック取込結果区分;
          this.$modal.show('アラート');
          return;
        }
        this.ダイアログを開く('取込完了ダイアログ');
      })
      .catch((error: any) => {
        this.APIアラートダイアログを開く(error.data);
      });
  }

  private async バーコードブック帳票を印刷する(): Promise<void> {
    const 印刷依頼 = {
      バーコードブック帳票商品一覧 : this.バーコードブック帳票商品一覧,
    };
    const ファイル名 = 'バーコードブック_' + moment().format('YYYYMMDDhhmmss') + '.pdf';
    this.ダイアログを閉じる('印刷ダイアログ');
    await download.バーコードブック帳票を出力する(ファイル名, 印刷依頼)
      .catch((error: any) => {
        this.APIアラートダイアログを開く(error.data);
      });
  }

  private APIアラートダイアログを開く(data: any) {
    this.アラートメッセージ = [data.message];
    if (data.errors !== null && data.errors !== undefined) {
      for (const エラー of data.errors) {
        this.アラートメッセージ = this.アラートメッセージ.concat(['・' + エラー]);
      }
    }
    this.$modal.show('アラート');
  }

}
